var Block_Cards_Selector = {
    init:function(){
        $(window).resize(function(){
            Block_Cards_Selector.resize();
        })
        Block_Cards_Selector.resize();

        $(".block-cards-with-selector .cards-container").each(function(){
            $(this).find(".item").each(function(i){
                $(this).css({
                    "-webkit-transition-delay": (i * 100) + "ms",
                    "transition-delay": (i * 100) + "ms"
                });
            });
        });

        $(".block-cards-with-selector .nav-btn").on("click touchend", function(e){
           if(e.type == "touchend"){
               $(this).off("click");
           }

           Block_Cards_Selector.change_selector($(this).index());
        });


    },
    change_selector:function(pID){
        Debug.log("CHANGE SELECTOR");
        $(".block-cards-with-selector .nav-btn").each(function(){
            if($(this).index() == pID){
                var _this = $(this);

                setTimeout(function(){
                    _this.addClass("selected");
                }, 200);
            }else{
                $(this).removeClass("selected");
            }
        });
        $(".block-cards-with-selector .cards-container").each(function(){
            if($(this).index() == pID){
                var _this = $(this);

                setTimeout(function(){
                    _this.addClass("selected");
                }, 200);
            }else{
                $(this).removeClass("selected");
            }
        })
        setTimeout(function(){
          Block_Cards_Selector.resize()
        }, 250);
    },
    resize:function(){
        // var _max_height = 0;
        // $('.block-cards-selector .cards-container').each(function(){
        //     _max_height = Math.max(_max_height, $(this).outerHeight());
        // })

        // $(".block-cards-selector .cards-slider").css({height:_max_height});
        var _current_height = $(".block-cards-with-selector .cards-container.selected").outerHeight();
        console.log(_current_height);
        $(".block-cards-with-selector .cards-slider").css({ height: _current_height });
    }
}

$(window).load(function(){
    if($(".block-cards-with-selector").length){
        Block_Cards_Selector.init();
    }
})
